/** @format */

// src/App.js

import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./parts/header";
import Home from "./parts/home";
import AboutUsPage from "./parts/AboutUsPage.jsx";
import Services from "./parts/services.jsx";
import Menu from "./parts/Menu.jsx";
import Gallery from "./parts/Gallery.jsx";
import ContactAndReservationsPage from "./parts/ContactAndReservationsPage.jsx";
import Footer from "./parts/Footer.jsx";
import AOS from "aos";
import "aos/dist/aos.css";
import "./App.css";

// A new component to hold the content of the main page
const MainPage = () => (
  <>
    <section id="home">
      <Home />
    </section>
  </>
);

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
    });
  }, []);

  return (
    <Router>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <main className="App" style={{ flex: 1 }}>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/services" element={<Services />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact-us" element={<ContactAndReservationsPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;